import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './HomePage.module.css';
import ParticlesBackground from '../../components/ParticlesBackground/ParticlesBackground';
import WavesBackground from '../../components/WavesBackground/WavesBackground';
import useTypingEffect from '../../hooks/useTypingEffect';

const HomePage: React.FC = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const fullText = 'Conor Hutchins Portfolio Site 💻';
  const displayedText = useTypingEffect(fullText);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name) {
      navigate(`/game?name=${name}`);
    }
  };

  return (
    <div className={styles.homePage}>
      <div className={styles.bgGradient}></div>
      <div className={styles.bgGrid}></div>
      {/* 3D animation for depth - using memoised components */}
      <div className={styles.depthAnimation}>
        <WavesBackground />
        <ParticlesBackground />
      </div>
      {/* Hero section with animated typing */}
      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <h1 className={styles.typingHeader}> 
            <span className={styles.gradientText}>{displayedText.replace('💻', '')}</span>
            {displayedText.includes('💻') && '💻'}
            <span className={styles.cursor}>|</span>
          </h1>
          <p className={styles.heroTagline}>
            👋 Hi I'm Conor, I'm a Software Engineer who specialises in{' '}
            <span className={styles.boldUnderlined}>Javascript</span>,{' '}
            <span className={styles.boldUnderlined}>Typescript</span>,{' '}
            <span className={styles.boldUnderlined}>ReactJS</span>,{' '}
            <span className={styles.boldUnderlined}>React Native</span> and{' '}
            <span className={styles.boldUnderlined}>Vue</span>
          </p>
        </div>
      </section>
      
      {/* Main content with two columns */}
      <div className={styles.mainContent}>
        {/* Left column: Game section */}
        <section className={styles.gameSection}>
          <div className={styles.sectionCard}>
            <h2 className={styles.sectionTitle}>Try My Interactive Game</h2>
            <p className={styles.sectionDesc}>
              This site has been built with{' '}
              <span className={styles.boldUnderlined}>TypeScript</span>,{' '}
              <span className={styles.boldUnderlined}>ReactJS</span>,{' '}
              <span className={styles.boldUnderlined}>React Hooks</span> and{' '}
              <span className={styles.boldUnderlined}>CSS Modules</span>
            </p>
            <div className={styles.gameInstructions}>
              <h3>How to play</h3>
              <p className={styles.instructions}>
                Use your mouse or tap screen on mobile to move around and consume blobs smaller than you!
              </p>
            </div>
            <form onSubmit={handleSubmit} className={styles.form}>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your name here..."
                className={styles.input}
                required
              />
              <button type="submit" className={styles.startButton}>
                START GAME
              </button>
            </form>
          </div>
        </section>
        
        {/* Right column: Portfolio navigation */}
        <section className={styles.portfolioSection}>
          <div className={styles.sectionCard}>
            <h2 className={styles.sectionTitle}>Explore My Work</h2>
            <p className={styles.sectionDesc}>
              Look through my projects and experience as a software engineer
            </p>
            <div className={styles.portfolioLinks}>
              <Link to="/projects" className={styles.portfolioLink}>
                <span className={styles.linkIcon}>📁</span>
                <div>
                  <h3>Projects</h3>
                  <p>See examples of my work</p>
                </div>
              </Link>
              <Link to="/experience" className={styles.portfolioLink}>
                <span className={styles.linkIcon}>💼</span>
                <div>
                  <h3>Experience</h3>
                  <p>View my professional journey</p>
                </div>
              </Link>
              <Link to="/techstack" className={styles.portfolioLink}>
                <span className={styles.linkIcon}>🔧</span>
                <div>
                  <h3>Tech Stack</h3>
                  <p>Technologies I work with</p>
                </div>
              </Link>
              <Link to="/contact" className={styles.portfolioLink}>
                <span className={styles.linkIcon}>✉️</span>
                <div>
                  <h3>Contact</h3>
                  <p>Get in touch with me</p>
                </div>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default HomePage;